'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.docs', {
    url: '/docs',
    templateUrl: '/app/states/docs/docs.html',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      docs: function (flow, $http) {
        return $http.get('/api/v1/me/documents').then(_.property('data'));
      }
    },
    controller: function ($scope, $window, $state, $interval, $http, docs) {
      function update () {
        if (!_.find($scope.docs, {status: 'pending'})) {
          return;
        }
        $http.get('/api/v1/me/documents').then(_.property('data')).then( function (docs) {
          _.filter($scope.docs, {status: 'pending'}).forEach( function (doc) {
            var newDoc = _.find(docs, {_id: doc._id});
            if (newDoc) {
              _.assign(doc, newDoc);
            }
          });
        });
      }
      var interval = $interval(update, 5000, 0, false);
      $scope.$on('$destroy', function () {
        $interval.cancel(interval);
      });
      $scope.docs = docs;
      $scope.config = { itemsPerPage: 10, maxPages: 3 };
      _.forEach(docs, function (doc) {
        doc.createdAt = new Date(doc.createdAt);
        doc.sourceName = doc.sourceParams.byteName || '';
      });
      $scope.openDoc = function (doc) {
        if (doc.status == 'pending') { return; }
        $scope.$popup('pdf', { type: 'user', src: doc });
      };
      $scope.download = function ($event, doc) {
        $event.stopPropagation();
        $window.open('/api/v1/me/documents/' + doc._id + '/pdf?download=true');
      };
      $scope.source = function ($event, doc) {
        $event.stopPropagation();
        $state.go('^.module.lesson.byte', doc.sourceParams);
      };
    }
  });

});
